import {
  Switch as ChakraSwitch,
  SwitchProps as ChakraSwitchProps,
  ThemingProps,
  forwardRef,
} from '@chakra-ui/react';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';

export interface SwitchProps
  extends OmitChakraProps<ChakraSwitchProps, keyof ThemingProps> {
  size?: never;
}

export const Switch = forwardRef<SwitchProps, 'input'>((props, ref) => {
  return <ChakraSwitch {...props} ref={ref} />;
});
